export default {
	initOpen: false,
	tagline: 'We are\nBüro',
	pages: [
		{
			link: 'https://burocratik.com',
			label: 'Homepage',
			thumbnail: [
				{
					url: '/imgs/home.jpg',
					type: 'image',
					extension: 'image/png',
					width: 180,
					height: 140,
				},
			],
		},
		{
			link: 'https://burocratik.com/studios',
			label: 'Studios',
			thumbnail: [
				{
					url: '/imgs/studios.jpg',
					type: 'image',
					extension: 'image/png',
					width: 180,
					height: 140,
				},
			],
		},
		{
			link: 'https://burocratik.com/recognition',
			label: 'Recognition',
			thumbnail: [
				{
					url: '/imgs/recognition.jpg',
					type: 'image',
					extension: 'image/png',
					width: 180,
					height: 140,
				},
			],
		},
		{
			link: 'https://burocratik.com/work',
			label: 'Work',
			thumbnail: [
				{
					url: '/imgs/work.jpg',
					type: 'image',
					extension: 'image/png',
					width: 180,
					height: 140,
				},
			],
			children: [
				{
					label: 'Branding',
					link: 'https://www.burocratik.com/branding',
				},
				{
					label: 'Naming',
					link: 'https://www.burocratik.com/naming',
				},
			],
		},
		{
			link: 'https://18.burocratik.com',
			label: '18 Years of Büro',
			thumbnail: [
				{
					type: 'video',
					mediaType: 'video/mp4',
					width: 180,
					height: 140,
					sources: [
						{
							breakpoint: 'default',
							url: '/videos/18years.mp4',
							width: 180,
							height: 140,
							type: 'video/mp4',
						},
					],
				},
			],
		},
	],
	socials: [
		{
			link: 'https://linkedin.com/company/burocratik',
			label: 'LinkedIn',
		},
		{
			link: 'https://www.instagram.com/burocratik/',
			label: 'Instagram',
		},
		{
			link: 'https://www.facebook.com/Burocratik/',
			label: 'Facebook',
		},
		{
			link: 'https://twitter.com/burocratik',
			label: 'Büro on X',
		},
	],
}
